import FormattedMessage from 'I18n/components/FormattedMessage';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RequireEmailAddress = ({
  requireEmail,
  onChange
}) => /*#__PURE__*/_jsxs(TFlex, {
  align: "center",
  children: [/*#__PURE__*/_jsx(Toggle, {
    marginInlineEnd: "300",
    size: "extra-small",
    checked: requireEmail,
    onChange: onChange
  }), /*#__PURE__*/_jsx(Text, {
    marginBlock: "0",
    marginInlineEnd: "100",
    as: "p",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "createLink.shareOptions.requireEmailAddress"
    })
  }), /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "createLink.shareOptions.requireEmailAddressHelpDescription"
    }),
    children: /*#__PURE__*/_jsx(View, {
      cursor: "pointer",
      children: /*#__PURE__*/_jsx(InfoIcon, {
        color: "do-not-use-battleship"
      })
    })
  })]
});
export default RequireEmailAddress;